import React from 'react';
import TabbedPage from '../../../../Elements/TabbedPage';
import GeneralEntryLogFigma from '../../../../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../../../../Elements/CommentsEntryLogDescription';
import AttachmentsComponent from '../../../../Elements/AttachmentsComponent';
import LogComponent from '../../../../Elements/LogComponent';
import TpCreditMemoDetailsInfoTab from './TpCreditMemoDetailsInfoTab';
import TpCreditMemoDetailLineTab from './TpCreditMemoDetailLineTab';
import InvoicePdfPreviewComponent from '../../../../Elements/InvoicePdfPreviewComponent';
import TpCreditMemoInvoiceViewDescription from './TpCreditMemoInvoiceViewDescription';

export default class TpCreditMemoDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  tpCreditMemoId = this.urlParams.get('id');

  componentDidMount() {}

  tabs = [
    {
      label: 'Information',
      id: 'info',
      icon: 'fa-solid fa-info',
      component: <TpCreditMemoDetailsInfoTab tpCreditMemoId={this.tpCreditMemoId} />,
    },
    {
      label: 'Line Items',
      id: 'lineitems',
      icon: 'fa-solid fa-file-invoice',
      component: <TpCreditMemoDetailLineTab tpCreditMemoId={this.tpCreditMemoId} />,
    },
    {
      label: 'Invoice View',
      id: 'invoiceviewreuse',
      icon: 'fa-solid fa-eye',
      component: (
        <InvoicePdfPreviewComponent
          id={this.tpCreditMemoId}
          invoiceDescription={TpCreditMemoInvoiceViewDescription}
          attachRoleKey='tpcreditmemo_createandmodifycredit'
          excelWordRoleKey='tpcreditmemos_view'
          hideSearchStrip={true}
        />
      ),
    },
    {
      label: 'Comments',
      id: 'comments',
      icon: 'fa-solid fa-comments',
      component: (
        <GeneralEntryLogFigma
          description={CommentsEntryLogDescription}
          context={{ entityTypeId: 503, entityId: this.tpCreditMemoId }}
        />
      ),
    },
    {
      label: 'Attachments',
      id: 'attachments',
      icon: 'fa-solid fa-paperclip',
      component: (
        <AttachmentsComponent
          entityTypeId={503}
          entityId={this.tpCreditMemoId}
          enableAddNew={true}
        />
      ),
    },
    {
      label: 'Logs',
      id: 'logs',
      icon: 'fa-solid fa-stream',
      component: (
        <LogComponent
          entityType='CreditMemo'
          entityId={this.tpCcreditMemoId}
        />
      ),
    },
  ];

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('id');
    return `Third-Party Credit Memo ${id ? '- ' + id : 'Details'}`;
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
